import React, { Component } from "react";
import Field from "./fields";
import { Row, Col } from "react-flexbox-grid";

import { Loadable } from "components/support";

import styles from "./styles";

import Subheader from "material-ui/Subheader";

class CustomInfoView extends Component {
  createOptionsForSelect = prop => {
    const allOptions = [{ label: "Selecione uma opção", value: "" }];

    if (!!prop) {
      prop.forEach(options =>
        allOptions.push({ label: options.trim(), value: options.trim() })
      );
    }

    return allOptions;
  };

  render() {
    const { customer, viewModel, onChange, customFieldsErrors } = this.props;
    const { loading, customer_custom_fields } = viewModel;
    const { custom_fields } = customer;

    return (
      <div className="grid-container">
        <Row>
          <Col xs={12}>
            <Loadable loading={loading}>
              <div className="grid-container mt-sm mb-sm">
                <Row>
                  <Col xs={12} md={10}>
                    <Subheader style={styles.subheader}>
                      Campos marcados com * são obrigatórios!
                    </Subheader>
                  </Col>
                </Row>
                <Row>
                  {customer_custom_fields.map((field, index) => (
                    <Field
                      key={index + 1}
                      type={field.type}
                      name={field.required ? `${field.name}*` : field.name}
                      options={this.createOptionsForSelect(field.options)}
                      optionsForRadioButton={field.options}
                      value={custom_fields[field.uuid]}
                      onValueChange={(_, value) =>
                        onChange(
                          "custom_fields",
                          field.uuid,
                          field.type === "phone"
                            ? value.replace(/\D/g, "")
                            : value
                        )
                      }
                      errorText={customFieldsErrors[field.uuid]}
                    />
                  ))}
                </Row>
              </div>
            </Loadable>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CustomInfoView;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/form/custom-info/view.jsx